const WHATSAPP_NUMBER = '56976360111';

export function openWhatsAppMessage(message) {
  if (typeof window === 'undefined') {
    return;
  }

  const safeMessage = typeof message === 'string' ? message.trim() : '';
  const encoded = encodeURIComponent(safeMessage || 'Hola, necesito más información.');
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;

  window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
}
